import { set, unionBy } from 'lodash'

export default {
	setUser(state, data) {
		let webTokens = []
		if (data.auth && data.auth.webTokens) {
			webTokens = data.auth.webTokens
			delete data.auth
		}
		for (let v in state.user) {
			state.user[v] = data[v]
		}
		state.user.webTokens = webTokens
	},

	setNow(state) {
		state.now = new Date()
	},

	clearUser(state, data) {
		state.user.id = null
		state.user.roles = []
		state.user.name = null
		state.user.phone = null
		state.user.avatar = null
		state.user.token = null
	},

	setLoaded(state, payload) {
		state.loaded[payload.path].add(payload.id)
	},

	updateChatMessages(state, payload) {
		let index = state.chats.findIndex((c) => c.id === payload.chat)
		if (!index < 0) return
		let preview = 'Новое сообщение'

		let fresh = JSON.parse(JSON.stringify(state.chats[index]))
		if (payload.message) {
			if (payload.message.text) preview = payload.message.text
			fresh.messages.push(payload.message)
		}

		if (payload.messages) {
			if (payload.after) fresh.messages = fresh.messages.concat(payload.messages)
			fresh.messages = payload.messages.concat(fresh.messages)

			let last = fresh.messages[fresh.messages.length - 1]
			if (last.text) preview = last.text
		}

		fresh.preview = preview
		state.chats.splice(index, 1, fresh)
	},

	setChatMessages(state, payload) {
		const { chat, messages } = payload
		const chatIndex = state.chats.findIndex((c) => c.id === chat)
		state.chats[chatIndex].messages = messages
	},

	// generic state mutations

	updateState(state, payload) {
		set(state, payload.path, payload.data)
	},

	setArray(state, payload) {
		if (!state[payload.path]) return
		state[payload.path] = payload.data
	},

	addToArray(state, payload) {
		if (!state[payload.path]) return
		state[payload.path].push(payload.data)
	},

	unshiftToArray(state, payload) {
		if (!state[payload.path]) return
		state[payload.path].unshift(payload.data)
	},

	concatToArray(state, payload) {
		if (!state[payload.path]) return
		if (payload.unshift) {
			state[payload.path] = payload.data.concat(state[payload.path])
		} else {
			state[payload.path] = state[payload.path].concat(payload.data)
		}
	},

	updateInArray(state, payload) {
		if (!state[payload.path]) return
		let index = state[payload.path].findIndex((v) => v.id === payload.data.id)
		if (index < 0)
			return this.commit(payload.unshift ? 'unshiftToArray' : 'addToArray', payload)

		if (payload.updates) {
			let obj = { ...state[payload.path][index] }
			for (let i = 0; i < payload.updates.length; i++) {
				let p = payload.updates[i].path
				obj[p] = payload.updates[i].data
			}
			state[payload.path].splice(index, 1, obj)
		} else {
			state[payload.path].splice(index, 1, payload.data)
		}
	},

	removeFromArray(state, payload) {
		if (!state[payload.path]) return
		let index = state[payload.path].findIndex((v) => v.id === payload.data)
		if (index < 0) return
		state[payload.path].splice(index, 1)
	},

	removeFromFlatArray(state, payload) {
		if (!state[payload.path]) return
		let index = state[payload.path].indexOf(payload.data)
		if (index < 0) return
		state[payload.path].splice(index, 1)
	},

	unionToArray(state, payload) {
		if (!state[payload.path]) return
		state[payload.path] = unionBy(state[payload.path], payload.data, 'id')
	},

	setTypingUser(state, payload) {
		state.typingUsers.push(payload.from)
	},

	removeTypingUser(state, payload) {
		state.typingUsers = state.typingUsers.filter(u => u !== payload.from)
	},

	updateMessage(state, payload) {
		const { chat, id, text } = payload
		const chatIndex = state.chats.findIndex((c) => c.id === chat)
		const messageIndex = state.chats[chatIndex].messages.findIndex(m => m.id === id)

		state.chats[chatIndex].messages[messageIndex].text = text
	},

	deleteMessage(state, payload) {
		const { chat, id } = payload
		const chatIndex = state.chats.findIndex((c) => c.id === chat)
		if (chatIndex === -1) return

		const messageIndex = state.chats[chatIndex].messages.findIndex(m => m.id === id)
		if (messageIndex === -1) return

		state.chats[chatIndex].messages.splice(messageIndex, 1)
	},

	updateReadBy(state, payload) {
		const { chat, readBy } = payload
		const chatIndex = state.chats.findIndex((c) => c.id === chat)
		if (chatIndex === -1) return

		state.chats[chatIndex].readBy = readBy
	},
}
